export const selectStateList = (state) => state.Location.stateList;
export const selectLocation = (state) => state.Location.currentLocation;
export const selectIsLoading = (state) => state.Location.isLoading;
export const selectError = (state) => state.Location.error;
export const selectAllStateList = (state) => state.Location.allStateList;
